import { render, staticRenderFns } from "./CaisseDetails.vue?vue&type=template&id=febc7902&scoped=true&"
import script from "./CaisseDetails.vue?vue&type=script&lang=js&"
export * from "./CaisseDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaisseDetails.vue?vue&type=style&index=0&id=febc7902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febc7902",
  null
  
)

export default component.exports